<template>
  <div class="skill-checking">
    <img src="~@/assets/images/skill-validating.png">
    <p>
      <span>{{$t('upgrade_page_views_settled_in_before_settled_1129')}}</span>
      <span>{{$t('upgrade_page_views_settled_in_before_settled_1130')}}</span>
      <span>{{$t('upgrade_page_views_settled_in_before_settled_1131')}}</span>
      <span>{{$t('upgrade_page_views_settled_in_before_settled_1132')}}</span>
    </p>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.skill-checking {
  background: white;
  margin-top: 60px;
  height: 500px;
  border-radius: 8px;
  padding-top: 70px;
  width: 100%;
  display: flex;
  justify-content: center;
  img {
    display: block;
    width: 230px;
    height: 104px;
    margin-right: 80px;
  }

  p {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    color: #333333;
    span {
      margin-bottom: 5px;
      &:first-child {
        font-weight: 500;
        line-height: 31px;
        font-size: 22px;
        color: #333;
        margin-bottom: 15px;
        text-align: center;
      }
    }
  }
}
</style>